// src/pages/MeetTheTeam.jsx
import React, { useState } from "react";
import "../styles/MeetTheTeam.css";
import brushBackground from "../assets/brushBackground.png";
import platformLogos from "../assets/platformLogos.png";
import mobileLogos from "../assets/about-us-mobile.png";
import { Link } from "react-router-dom";


const teamMembers = [
  {
    id: 1,
    name: "Mandy Holman",
    title: "Founder and Chief Marketing Strategist",
    image: require("../assets/mandy-headshot.jpg"),
    bio: [
      "“I'm Mandy Holman, the founder and chief marketing strategist at Growth Lab, a boutique digital marketing agency built on the belief that small teams can drive big impact. Since 2013, I’ve been helping brands cut through the noise and grow with clarity, confidence, and measurable results.",
"With an MBA from the University of Utah and over a decade of experience in performance marketing, I’ve had the privilege of working with a range of businesses—from scrappy startups to Fortune 500 firms—crafting tailored marketing strategies that generate real growth. My passion lies in partnering with small to mid-sized companies, especially those looking to set up their first serious marketing program or refine what’s already in place.",
"At Growth Lab, we intentionally stay lean. That means minimal overhead, direct access to strategic thinking, and a no-fluff approach to execution. I serve as a fractional CMO for many of our clients, bringing senior-level insight without the full-time commitment, and ensuring every dollar works harder.",
"If you're looking for a thoughtful, results-driven partner to help build or scale your marketing engine, I'm here to help.”"
    ],
    linkedin: "https://www.linkedin.com/in/mandy-holman-86428ba5/",
    email: "mailto:mandy@growthlabadvertising.com",
  },
    {
    id: 2,
    name: "Q'Anteria Roberson",
    title: "Director of Social Media",
    image: require("../assets/q-headshot.jpg"),
    bio: [
      "“Q'Anteria “Q” Roberson brings an unbeatable blend of strategic thinking, creative insight, and data-driven execution to Growth Lab Advertising. As a seasoned Paid Media Strategist, Q specializes in building full-funnel campaigns across Meta, TikTok, and LinkedIn for a diverse range of clients—from eCommerce and travel to health, tech, and B2B. With a background in performance marketing and a sharp eye for audience psychology, Q crafts campaigns that don’t just get clicks—they convert. Her work consistently elevates brand visibility, drives qualified traffic, and maximizes ROI through precise targeting, compelling ad creative, and continuous optimization. Whether she's launching an organic social strategy for an emerging tech platform, managing a multi-tiered Meta funnel for a luxury lifestyle brand, or helping niche clients break into new markets, Q brings clarity, precision, and flair to every project. When she's not geeking out over creative hooks or conversion paths, you'll find Q collaborating cross-functionally with content teams, analysts, and client partners to keep Growth Lab campaigns sharp, scalable, and ahead of the curve.”"
    ],
    linkedin: "https://www.linkedin.com/in/qroberson/",
    email: "mailto:q@growthlabadvertising.com",
  },
    {
    id: 3,
    name: "Lexi Hobbs",
    title: "Director of Paid Search",
    image: require("../assets/lexi-headshot.png"),
    bio:[
      "“Lexi Hobbs is a Senior Account Manager at Growth Lab Advertising, specializing in PPC and performance measurement. With a robust background in both in-house and agency roles, Lexi is passionate about driving real business growth for her clients. She has previously held a director-level position, where she led a team of over 15 PPC specialists, managed the highest-tier agency partnerships with Google Ads and Microsoft Ads, and developed the agency’s PPC annual and quarterly strategies for the executive team. Lexi enjoys partnering with SMBs to help them scale and exceed revenue goals, while also having experience managing large enterprise accounts. She is committed to turning clients' visions into reality through paid ads, staying at the forefront of the latest trends in digital marketing to ensure optimal results.”"
    ],
    linkedin: "https://www.linkedin.com/in/lexihobbs/",
    email: "mailto:lexi@growthlabadvertising.com",
  },  
  {
    id: 4,
    name: "Devin Holman",
    title: "Director of Technology",
    image: require("../assets/devin-headshot.jpg"),
    bio:[
      "“Devin Holman is a full-stack software engineer with deep expertise in eCommerce, web tracking, and backend development. He’s led technical integrations for Shopify, WordPress, and custom Node.js apps—supporting brands across industries with SEO, analytics, and scalable infrastructure. With a strong foundation in both frontend and backend systems, Devin blends clean code with conversion-focused strategies that deliver real results.”"
    ],
    linkedin: "https://www.linkedin.com/in/devin-holman/",
    email: "mailto:devin@growthlabadvertising.com",
  },  
  {
    id: 5,
    name: "Callie de los Reyes",
    title: "Director of Life Cycle Marketing",
    image: require("../assets/callie2.JPG"),
    bio:[
      "“Callie is a strategic and client-focused email marketing and client success specialist at Growth Lab. With a background in digital marketing that includes experience at Disruptive Advertising, she brings thoughtful, out-of-the-box thinking to every campaign and client interaction. Callie began her professional journey outside of marketing and transitioned into the digital space because of her love for connecting brands with audiences in meaningful ways. She thrives on learning new strategies in email and lifecycle marketing and applies that knowledge to help clients scale their businesses with clarity and impact. At Growth Lab, Callie is known for her client-first mindset, collaborative communication, and ability to translate complex strategy into results that matter. Outside of work, she’s a true community person who loves time with her dog, cheering at Dodgers games, and diving into true crime and concert culture. If you want a partner who brings equal parts strategy, creativity, and care to your marketing program, Callie is someone you’ll be excited to work with.”"
    ],
    linkedin: "https://www.linkedin.com/company/growth-lab-advertising",
    email: "mailto:callie@growthlabadvertising.com",
  },
  {
    id: 6,
    name: "Becca Dougal",
    title: "Sr. Paid Search Strategist",
    image: require("../assets/becca.jpg"),
    bio:[
      "“Becca brings her passion for relationship-driven strategy and results-oriented thinking to her role on the Growth Lab client team. Her background includes account and project management in performance-focused environments where connecting client goals to tactical execution is key. Before joining Growth Lab, Becca worked as an account manager focused on delivering disciplined, results-driven marketing strategies while building strong client relationships. She’s known for her ability to translate business priorities into clear strategic plans and coordinate execution that moves the needle. Outside of her professional work, Becca channels her creativity into music, visual arts, and outdoor exploration — all of which inform her approach to problem-solving and campaign strategy in the studio. Becca’s collaborative mindset and commitment to client success make her a trusted partner for Growth Lab clients who want not just great work but a partner in long-term growth.”"
    ],
    linkedin: "https://www.linkedin.com/company/growth-lab-advertising",
    email: "mailto:becca@growthlabadvertising.com",
  },
  {
    id: 7,
    name: "Emily Morineau",
    title: "Sr. Graphic Designer",
    image: require("../assets/emily.png"),
    bio:[
      "“Emily is Growth Lab’s Creative Design and Brand Experience lead, bringing an eye for visual clarity and user-centric design to every project we tackle. Before joining Growth Lab, Emily built her career through hands-on work in brand identity, digital product design, and creative strategy, developing designs that look beautiful and perform intuitively. She founded and grew her own design studio where she partnered deeply with clients to define brand character, craft visual narratives, and turn aesthetic ideas into real business-driven outcomes. Emily approaches design as both craft and communication. She ensures every brand touchpoint feels intentional, aligns with strategic goals, and creates a connection with audiences that lasts. Her style combines thoughtful structure with a fresh creative voice that elevates every project she touches. When she’s not shaping visual experiences, Emily loves exploring creative culture and drawing inspiration from everyday life.”"
    ],
    linkedin: "https://www.linkedin.com/company/growth-lab-advertising",
    email: "mailto:emily@growthlabadvertising.com",
  },
];

const MeetTheTeam = () => {

  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <div className="meet-the-team">
      <section className="mtt-intro-section">
        <div className="mtt-intro-wrap">
          <h1>Meet the Team</h1>
          <p>
            At Growth Lab Advertising, we believe great ideas come to those who take the bold approach. We’re not here to play it safe. We’re here to experiment, learn fast, and scale what works. Our clients trust us not only for our fresh perspectives but for our ability to consistently deliver. Whether it’s building a brand from the ground up or optimizing a marketing strategy for maximum ROI, Growth Lab Advertising has the team that turns bold ideas into measurable success.
          </p>
        </div>

{/* Team Images */}
<div className="team-images container">
  <div className="team-images-row">
    {teamMembers.slice(0, 4).map((member) => (
      <div
        key={member.id}
        className="team-image"
        style={{ backgroundImage: `url(${member.image})` }}
        onClick={() => setSelectedMember(member)}
      />
    ))}
  </div>

  <div className="team-images-row">
    {teamMembers.slice(4).map((member) => (
      <div
        key={member.id}
        className="team-image"
        style={{ backgroundImage: `url(${member.image})` }}
        onClick={() => setSelectedMember(member)}
      />
    ))}
      {/* Invisible placeholder circle */}
  <div className="team-image team-placeholder" />
  </div>
</div>


        <div className="click-to-learn text-center mt-3">  
          <p><img src={require("../assets/union-icon.png")} alt="Click Icon" className="mtt-click-icon" />Click the Image to Learn More</p>
        </div>
      </section>

      <section className="mtt-cta-section">
        <div className="mtt-cta-wrap">
          <h2>Work With a Team That Gets You</h2>
          <p>
            At Growth Lab Advertising we’re not just a team, <span>you’re getting a dedicated growth partner</span>.
            We bring the strategy, creativity, and execution needed to help your brand stand out and scale fast.
            Whether you’re launching something new or looking to break through a plateau,
            our team is ready to dive in and deliver.
          </p>
          <div className="mtt-results-text">
            <p>Let’s build something that drives results.</p>
          </div>

{/* Logos Section */}
        <div className="mtt-logos-section">
          <img
            src={brushBackground}
            alt="Brush Background"
            className="brush-background desktop"
          />
          <img
            src={platformLogos}
            alt="Platform Logos"
            className="platform-logos desktop"
          />
          <img
            src={mobileLogos}
            alt="Platform Logos Mobile"
            className="platform-logos-mobile"
          />
        </div>

                  {/* Call-to-Action */}
        <div className="mtt-cta">
          <p className="mtt-cta-text">
            Click below to Schedule Your FREE Growth Audit!
          </p>
          <Link to="/lead-form" className="mtt-cta-button">
            Get Started
          </Link>
        </div>
        </div>
      </section>
      
    {selectedMember && (
        <div className="team-modal">
            <div className="team-modal-content">
            <button className="team-modal-close" onClick={() => setSelectedMember(null)}>
                &times;
            </button>

            <div className="team-modal-left">
                <img src={selectedMember.image} alt={selectedMember.name} />
                <div className="team-modal-contact">
                <span className="connect-label">Let’s Connect:</span>
                <div className="connect-icons">
                    <a href={selectedMember.linkedin} target="_blank" rel="noopener noreferrer">
                        <img src={require("../assets/linkedin-icon2.png")} alt="LinkedIn" />
                    </a>
                    <a href={selectedMember.email}>
                        <img src={require("../assets/email-icon2.png")} alt="Email" />
                    </a>
                </div>
                </div>
            </div>

            <div className="team-modal-right">
                <h2>{selectedMember.name}</h2>
                <h4>{selectedMember.title}</h4>
                <div className="team-modal-bio">
                    {selectedMember.bio.map((paragraph, idx) => (
                        <p key={idx}>{paragraph}</p>
                    ))}
                </div>
            </div>
            </div>
        </div>
        )}
    </div>
  );
};

export default MeetTheTeam;
